import appEvents from 'constants/appEvents.constant';
import tripItemTypes from '../trip-item-types';
import suppliers from './../../supplier/suppliers';

export default function TripFactory(
    $q,
    $rootScope,
    $state,
    $http,
    $stateParams,
    basketService,
    userService,
    l10nService,
    tripAPI,
    loginFactory,
    authService,
    tripUtils,
    tripOptionsService,
    travellerUtils,
    paymentFactory,
    luggageService,
    railAmendmentService,
) {
    'ngInject';

    let showSendTripBlock = false;
    let showVerifyTripBlock = false;
    let luggageData = null;

    function getTripDetailsWithCardData(tripId) {
        return tripAPI.fetchTripDetailsWithCardData(tripId).then(function(response) {
            const details = response.data;
            details.Travelers = travellerUtils.processTravellers(details.Travelers);
            return details;
        });
    }

    return {
        showSendTripBlock: function() {
            showSendTripBlock = true;
        },

        /**
         * Checks the visibility of a send block
         */
        isVisibleSendBlock: function() {
            const needShow = showSendTripBlock;

            /**
             * Reset value
             */
            showSendTripBlock = false;

            return needShow;
        },

        /**
         * Checks the visibility of a send block
         */
        isVisibleVerifyBlock: function() {
            const needShow = showVerifyTripBlock;

            /**
             * Reset value
             */
            showVerifyTripBlock = false;

            return needShow;
        },

        validateAllocation: function(trip) {
            return _.every(trip, function(tripGroup) {
                return _.every(tripGroup, function(item) {
                    if (item.rooms) {
                        return _.every(item.rooms, function(room) {
                            return room.user.id;
                        });
                    }

                    return item.user.id;
                });
            });
        },

        showCheckout: function(tripId, tripDepartmentId, tripValidation, clearBasket) {
            const stateParams = {
                id: tripId,
                department: tripDepartmentId,
                tripValidation,
            };

            /**
             * Clear items from basket
             */
            if (clearBasket) {
                basketService.clearBasket();
            }

            $state.go('main.trip.checkout', stateParams);
        },

        getTripCheckoutData: function(tripId) {
            return tripAPI.fetchTripCheckoutData(tripId)
                .then(({data}) => {
                    const checkoutData = data;

                    checkoutData.tripId = tripId;
                    checkoutData.travellersCount = checkoutData.Travelers.length;
                    luggageData = [];
                    return checkoutData;
            });
        },

        tripDetails: function(tripId, cardType, tripDepartmentId) {
            if (this.isHash(tripId)) {
                return tripAPI.fetchTripDetailsByHashCode(tripId)
                    .error(function() {
                        $state.go('login');
                    })
                    .then(function(response) {
                        const data = _.omit(response.data, 'TripDetailsResponse');
                        response.data.TripDetailsResponse.Travelers = travellerUtils.processTravellers(response.data.TripDetailsResponse.Travelers);
                        return loginFactory.getLocalization(response.data.TripDetailsResponse.Culture)
                            .then(function(localizationResponse) {
                                    l10nService.updateList(localizationResponse);

                                    if (!authService.isLoggedIn()) {
                                        const tripDetailsResponse = response.data.TripDetailsResponse;
                                        const regionalSettings = {
                                            Culture: tripDetailsResponse.Culture,
                                            Currency: tripDetailsResponse.Currency,
                                            DistanceUnit: tripDetailsResponse.DistanceUnit,
                                        };
                                        authService.saveAvailableServices({RegionalSettings: regionalSettings});
                                    }

                                    return _.extend(data, response.data.TripDetailsResponse);
                                }
                            );
                    });
            }
                //todo: investigate
                if (tripDepartmentId && userService.getCurrentDepartment() !== tripDepartmentId) {
                    const department = userService.getUserDepartment(tripDepartmentId);

                    if (!department) {
                        return $rootScope.$broadcast(appEvents.REDIRECT_TO_DEFAULT);
                    }

                    return loginFactory.changeDepartment(department)
                        .then(function(userData) {
                            authService.saveUser(userData);
                            return loginFactory.getAvailableServices().then(function(services) {
                                authService.saveAvailableServices(services);
                                $rootScope.$broadcast(appEvents.AVAILABLE_SERVICES_CHANGE, services);

                                return getTripDetailsWithCardData(tripId);
                            });
                        });

                }
                    return getTripDetailsWithCardData(tripId);


        },

        apisHasLevel: function(level, currentLevel) {
            if (_.isNumber(level)) {
                return level !== currentLevel;
            } else if (_.isArray(level)) {
                return level.indexOf(currentLevel) === -1;
            }
        },

        /**
         * Check if tripId is hash
         */
        isHash: function(tripId) {
            return tripId.toString().indexOf('-') !== -1;
        },

        validateTrip: function(tripId, tripDetails) {
            if (tripDetails && tripDetails.IsOfflineTrip) {
                return $q.when({
                    isValid: true,
                    errors: [],
                    warning: [],
                    paymentsValid: true,
                    paymentMethods: [],
                });
            }
            return tripAPI.validateTrip(tripId)
                .then(function(validationResponse) {
                    return {
                        isValid: validationResponse.data.IsValid,
                        errors: validationResponse.data.Errors,
                        warning: validationResponse.data.Warnings,
                        paymentsValid: _.isEmpty(validationResponse.data.PaymentMethods),
                        paymentMethods: paymentFactory.buildPaymentErrors(
                            validationResponse.data.PaymentMethods,
                            validationResponse.data.TripDetails
                        ),
                    };
                });
        },

        getValidationInfo: function(response) {
            const {ValidateTripResponse} = response;
            return {
                isValid: ValidateTripResponse.IsValid,
                errors: ValidateTripResponse.Errors,
                warning: ValidateTripResponse.Warnings,
                paymentsValid: _.isEmpty(ValidateTripResponse.PaymentMethods),
                paymentMethods: paymentFactory.buildPaymentErrors(
                    ValidateTripResponse.PaymentMethods,
                    ValidateTripResponse.TripDetails
                ),
            };
        },

        actionTrip: function(action, actionData, tripDetails, tripData) { // eslint-disable-line
            const allocatedTravellers = [];
            const selectedSeatPreferences = [];
            const {Confirm, Amend} = tripOptionsService.TRIP_ACTION;
            const isBooking = (action === Confirm || action === Amend);

            const luggageOptions = this.getLuggageData(tripData.LuggageOptions);

            angular.forEach(tripDetails.Hotels, function(hotel) {
                angular.forEach(hotel.rooms, function(room) {
                    allocatedTravellers.push({
                        TripItemId: hotel.Id,
                        PassengerId: room.user.id,
                        ProductType: tripOptionsService.PRODUCT_TYPE.Hotel,
                        authorizedBillBackChargeType: room.charges.id,
                    });
                });
            });

            angular.forEach(tripDetails.Cars, function(car) {
                allocatedTravellers.push({
                    PassengerId: car.user.id,
                    TripItemId: car.Id,
                    ProductType: tripOptionsService.PRODUCT_TYPE.Car,
                });
            });

            angular.forEach(tripDetails.EuRails, function(euRail) {
                for (const group of euRail.SeatPreferenceGroups) {
                    selectedSeatPreferences.push({
                        OriginStationId: group.OriginStationId,
                        DestinationStationId: group.DestinationStationId,
                        TripItemId: euRail.Id,
                        PositionCode: group.SelectedPositionCode,
                        FacilitiesCode: group.SelectedFacilitiesCode,
                        DirectionCode: group.SelectedDirectionCode,
                        CarriageTypeCode: group.SelectedCarriageTypeCode,
                        SeatTypeCode: group.SelectedSeatTypeCode,
                        DeckCode: group.SelectedDeckCode,
                    });
                }

                allocatedTravellers.push({
                    PassengerId: euRail.user.id,
                    TripItemId: euRail.Id,
                    ProductType: tripOptionsService.PRODUCT_TYPE.EuRail,
                });
            });

            function getTravelerIds() {
                const {Adult: adults, Child: children} = tripDetails.Travelers;
                return [...adults, ...children]
                    .filter((person) => person.SendDocumentation)
                    .map((person) => person.Id);
            }

            let itemType = null;
            let tripItemRailRecommendationId = null;

            const amendmentParameters = railAmendmentService.getAmendmentParameters();
            if (amendmentParameters) {
                itemType = amendmentParameters.isEuRails ? tripItemTypes.eurail : tripItemTypes.rail;
                tripItemRailRecommendationId = amendmentParameters.recommendationId;
            }

            const requestData = {
                SendDocumentationTravellers: getTravelerIds(),
                TripId: tripDetails.Id,
                BookingAction: action,
                CreditCard: isBooking ? actionData.getCreditCard() : null,
                PaymentCodes: isBooking ? actionData.getPaymentCodes() : null,
                PaymentMethod: isBooking ? actionData.getPaymentMethod() : null,
                AllocationRequests: allocatedTravellers,
                OutOfPolicyReasonCodeId: tripDetails.IsOfflineTrip ? null : actionData.getPolicyReason(),
                LowestFareReasonCodeId: tripDetails.IsOfflineTrip ? null : actionData.getFareReason(),
                ApprovalRequest: tripDetails.IsOfflineTrip ? null : actionData.getApprovalData(),
                LuggageOptionRequests: (luggageOptions.length) ? luggageOptions : null,
                HotelBookingMessages: tripDetails.Hotels
                    .filter(({Supplier, BookingMessage}) => Supplier === suppliers.amadeus.id || Supplier === suppliers.bookingCom.id && BookingMessage)
                    .map(({Id, BookingMessage}) => ({itemId: Id, message: BookingMessage})),
                JustificationText: tripData.IsJustificationTextRequired ? tripDetails.JustificationText : null,
                EuRailsSeatPreferences: selectedSeatPreferences,
                ItemType: itemType,
                TripItemRailRecommendationId: tripItemRailRecommendationId,
            };

            /**
             * An additional property, .IsCreditCardPayment, is being added to the .ApprovalRequest property
             * of the ActionTrip request.
             * true  : enters credit card details -or- checks the 'Enter card details after approval' checkbox.
             * false : payment method is Invoice
             */
            if (requestData.ApprovalRequest) {
                requestData.ApprovalRequest.IsCreditCardPayment
                    = actionData.getEnterAfterApproval() || !!requestData.CreditCard;
            }
            return tripAPI.actionTrip(requestData, tripDetails);
        },

        findItems: function(status, response, tripDetails) {
            let key = 'Flights';
            const tempObj = {};
            const failedItems = _.filter(response.BookingResponses, function(item) {
                return item.BookingStatus === status;
            });

            _.each(failedItems, function(item) {
                let tripItem = _.find(tripDetails.Flights, function(chr) {
                    return chr.Id === item.TripItemId;
                });

                if (tripItem) {
                    _.each(tripItem.FlightGroups, function(flightGroup) {
                        const ES = _.some(flightGroup.Flights, {Airplane: 'Train'});
                        const AMTRAK = _.some(flightGroup.Flights, {MarketingAirline: 'Amtrak'});
                        if (ES) {
                            key = 'Eurostar';
                        }
                        if (AMTRAK) {
                            key = 'Amtrak';
                        }
                    });
                }
                if (!tripItem) {
                    key = 'Hotels';
                    tripItem = _.find(tripDetails.Hotels, function(chr) {
                        return chr.Id === item.TripItemId;
                    });
                }
                if (!tripItem) {
                    key = 'Cars';
                    tripItem = _.find(tripDetails.Cars, function(chr) {
                        return chr.Id === item.TripItemId;
                    });
                }
                if (!tempObj[key]) {
                    tempObj[key] = [];
                }
                if (tripItem) {
                    tempObj[key].push(tripItem);
                }
            });
            return tempObj;
        },

        isCanBookByTime: function(tripDetail) {
            const hotelsTimeAvailable = true;
            const fromBasket = !tripDetail;
            let flightsTimeAvailable = true;
            let carsTimeAvailable = true;

            if (fromBasket) {
                _.forEach(
                    tripUtils.getFlights(tripDetail), function(flight) {
                        _.forEach(
                            flight.segments, function(segment) {
                                flightsTimeAvailable
                                    = flightsTimeAvailable && segment.canBeBooked;
                            }
                        );
                    }
                );
            }

            _.forEach(
                tripUtils.getCars(tripDetail), function(car) {
                    const departureTime = (fromBasket) ? car.pickUpDate : car.PickUpDate;

                    carsTimeAvailable
                        = carsTimeAvailable && moment(departureTime).isAfter(moment().endOf('day'));
                }
            );

            return flightsTimeAvailable && hotelsTimeAvailable && carsTimeAvailable;
        },

        updateItemPrices: function(src, dest) {
            src.forEach(function(item) {
                item.Prices = _.findWhere(dest, {TripItemId: item.Id}) || [];
            });
            return src;
        },

        everyItemCannotBeCancelled: function(tripDetails) {
            const items = this.getTripItems(tripDetails);
            return !_.find(items, {CanBeCancelled: true});
        },

        createEmptyLuggageData: function() {
            luggageData = [];
        },

        registerModel: function(travellerId, luggageModel) {
            if (_.find(luggageData, {traveller: travellerId})) {
                return;
            }

            luggageData.push({traveller: travellerId, model: luggageModel});
        },

        isLuggageModelRegistered: function(travellerId) {
            return !!_.find(luggageData, {traveller: travellerId});
        },

        getAllLuggageModels: function() {
            return luggageData;
        },

        getLuggageModel: function(travellerId) {
            return _.find(luggageData, {traveller: travellerId}).model;
        },

        getLuggageData: function(luggageOptions) {
            let luggageRequestData = [];

            _.each(luggageData, function(luggageModel) {
                const modelData = luggageService.getRequestData(luggageOptions, luggageModel.model);

                if (modelData.length) {
                    luggageRequestData = luggageRequestData.concat(modelData);
                }
            });

            return luggageRequestData;
        },

        getTripItems: function(tripDetails) {
            return tripDetails.Flights.concat(tripDetails.Cars, tripDetails.Hotels, tripDetails.EuRails);
        },

        getBookErrorTooltipContent: function(status, isUSRegion) { // eslint-disable-line
            let tooltipContent = '';

            // { OK = 0, OutsideOfHours = 1, CloseToDeparture = 2, ApprovalInProcess = 3 }
            if (status === 1) {
                tooltipContent = l10nService.localize('This request cannot currently be processed online. '
                    + 'Please try again during office hours, or for travel within the next 48 hours contact '
                    + 'our 24 hour emergency team on ');
            } else if (status === 2) {
                tooltipContent = l10nService.localize('This trip cannot be booked online as it is too close '
                    + 'to the departure time. Please contact your reservation team during working hours, or if '
                    + 'out of hours please contact our 24 hour emergency team on ');
            } else if (status === 3) {
                tooltipContent = l10nService.localize('This trip is currently pending approval and cannot be '
                    + 'booked');
            } else if (status === 4) {
                tooltipContent = l10nService.localize('No changes can be made as automatic booking '
                    + 'confirmation is in progress');
            }

            if (status === 2 || status === 1) {
                tooltipContent += (isUSRegion)
                    ? l10nService.localize('+01 (888) 339 – 15')
                    : l10nService.localize('+44 (0) 20 7843 9602');
            }

            return tooltipContent;
        },

        checkReviewRequirement: function(reviewModel) {
            const isFlightsReviewed = Object.getOwnPropertyNames(reviewModel.flights).length;
            const isCarsReviewed = Object.getOwnPropertyNames(reviewModel.cars).length;
            const isHotelsReviewed = Object.getOwnPropertyNames(reviewModel.hotels).length;
            return !isFlightsReviewed && !isCarsReviewed && !isHotelsReviewed;
        },

        generateReviewRequest: function(tripDetails, reviewComment, tripId) {
            const requestData = {
                TripId: tripDetails.Id,
                Comment: reviewComment,
                AcceptedItems: [],
                DeclinedItems: [],
            };

            if (this.isHash(tripId)) {
                requestData.Hash = tripId;
            }

            const {car, flight, hotel, rail} = tripItemTypes;

            _.forOwn(tripDetails.reviewModel.flights, function(isAccepted, itemId) {
                const requestField = (isAccepted) ? 'AcceptedItems' : 'DeclinedItems';
                requestData[requestField].push({TripItemId: itemId, TripItemType: flight});
            });

            _.forOwn(tripDetails.reviewModel.cars, function(isAccepted, itemId) {
                const requestField = (isAccepted) ? 'AcceptedItems' : 'DeclinedItems';
                requestData[requestField].push({TripItemId: itemId, TripItemType: car});
            });

            _.forOwn(tripDetails.reviewModel.hotels, function(isAccepted, itemId) {
                const requestField = (isAccepted) ? 'AcceptedItems' : 'DeclinedItems';
                requestData[requestField].push({TripItemId: itemId, TripItemType: hotel});
            });

            _.forOwn(tripDetails.reviewModel.rails, function(isAccepted, itemId) {
                const requestField = (isAccepted) ? 'AcceptedItems' : 'DeclinedItems';
                requestData[requestField].push({TripItemId: itemId, TripItemType: rail});
            });

             return $http.apiPOST('/trips/UpdateReviewTripItems', requestData);
        },

        // eslint-disable-next-line complexity
        getCardData: function(formData, isCardSave) {
            let fullName = formData.Holder ? formData.Holder : formData.CardHolderName;
            if (!fullName) {
                fullName = 'Test Tester';
            }

            return {
                'full_name': fullName, // eslint-disable-line
                month: formData.expire ? formData.expire.month : formData.ExpiryMonth,
                year: formData.expire ? '20' + formData.expire.year : '20' + formData.ExpiryYear,
                address1: formData.BillingAdress ? formData.BillingAdress : formData.AddressLine1,
                address2: formData.BillingAdress2 ? formData.BillingAdress2 : formData.AddressLine2,
                city: formData.City,
                state: formData.State,
                zip: formData.ZipCode ? formData.ZipCode : formData.Postcode,
                country: formData.country ? formData.country.value : formData.CountryCode,
                metadata: {
                    description: formData.Description,
                    issueMonth: formData.issue ? formData.issue.month : formData.StartMonth,
                    issueYear: formData.issue ? formData.issue.year : formData.StartYear,
                    issueNumber: formData.IssueNumber ? formData.IssueNumber : formData.IssueNumber,
                    shouldCardBeSaved: isCardSave,
                },
            };
        },
    };
}



// WEBPACK FOOTER //
// ./src/app/modules/trip/services/tripFactory.js